/**
 * description: 选择音频的弹出框
 * created by liu jinming
 * created on 2017.09.08
 */
'use strict';
angular
    .module('trsUploadAVNewServiceModule', ['videoCoverImagesModule'])
    .factory('trsUploadAVNewService', [
        '$q',
        '$modal',
        '$state',
        'trsHttpService',
        'editingCenterService',
        'processingMaterialService',
        function ($q, $modal, $state, trsHttpService, editingCenterService, processingMaterialService) {
            return {
                openVideoModal: function () {
                    var deffer = $q.defer();
                    let options = {
                        resourceType: '2',
                        isMulti: false,
                        isWeixin: $state.$current.name === 'wxeditpage'
                    };
                    editingCenterService.mediaSelector(options).then(function (result) {
                        if (result.type === 'videoLink') {
                            deffer.resolve({ html: result.html });
                        }
                        var videoHtml = {
                            html: [
                                {
                                    videoHtml: processingMaterialService.editVideoOrAudio(result.list),
                                },
                            ],
                        };
                        deffer.resolve(videoHtml);
                    });
                    return deffer.promise;
                },

                /**
                 * [type description]
                 *
                 * @param   {[type]}  type  [type description]
                 *
                 * @return  {[type]}        [return description]
                 */
                opennewAudioModal: function (type) {
                    var deffer = $q.defer();
                    let options = {
                        resourceType: '1',
                        isMulti: true
                    };
                    editingCenterService.mediaSelector(options).then(function (result) {
                        if (result.type === 'videoLink') {
                            deffer.resolve({ html: result.html });
                        }
                        var videoHtml = {
                            html: [
                                {
                                    videoHtml: processingMaterialService.editVideoOrAudio(result.list),
                                },
                            ],
                        };
                        deffer.resolve(videoHtml);
                    });
                    return deffer.promise;
                },

                /**
                 * [monitorVideoTranscoding description] 点击查询视频转码状态
                 * @param  {[type]} videoid [description] 视频id
                 * @return {[type]}         [description]
                 */
                monitorVideoTranscoding: function (videoid) {
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_videoInterfacesEncapsulation',
                        methodname: 'queryVideoTranscodingStatus',
                        VideoId: videoid, // item.AUDIOVIDEOID
                        resourceType: 'video/mp4',
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        if (data.DATA.code === 0) {
                            deffer.resolve(true);

                            /* $scope.isShow = false;*/
                        } else if (data.DATA.code != 0) {
                            deffer.resolve(false);
                        }
                    });
                    return deffer.promise;
                },

                /**
                 * [openCoverModal description] 视频封面图弹窗
                 * @param  {[type]} videoid [description] video id
                 * @return {[type]}         [description]
                 */
                openCoverModal: function (videoid) {
                    var deffer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './components/service/trsUploadAudioVedioNew/coverImages/videoCoverImages_tpl.html',
                        windowClass: 'video_cover_images',
                        backdrop: false,
                        keyboard: false,
                        controller: 'videoCoverImagesCtrl',
                        resolve: {
                            item: function () {
                                return {
                                    videoid: videoid,
                                };
                            },
                        },
                    });
                    // 关闭弹窗
                    modalInstance.result.then(
                        function (result) {
                            deffer.resolve(result);
                        },
                        function () {
                            deffer.reject('cancel');
                        }
                    );
                    return deffer.promise;
                },
            };
        },
    ]);
